import { IContestSpecialPeriod } from '@/components_v3/affiliate/contest/entities/cashback-offer/model/types';

/** API contest-service-v2: periods.from / periods.to — строго Y-m-d */
const ISO_DATE_PREFIX_RE = /^(\d{4})-(\d{2})-(\d{2})/;
const DOT_DATE_RE = /^(\d{2})\.(\d{2})\.(\d{4})/;

export function normalizeContestPeriodDateToYmd(value: string): string | null {
    const trimmed = value.trim();

    if (!trimmed) {
        return null;
    }

    const isoMatch = ISO_DATE_PREFIX_RE.exec(trimmed);

    if (isoMatch) {
        return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
    }

    const dotMatch = DOT_DATE_RE.exec(trimmed);

    if (dotMatch) {
        return `${dotMatch[3]}-${dotMatch[2]}-${dotMatch[1]}`;
    }

    return null;
}

function toYmdString(value: unknown): string | null {
    if (typeof value === 'string' && value.length > 0) {
        return normalizeContestPeriodDateToYmd(value);
    }

    if (typeof value === 'object' && value !== null && 'date' in value) {
        const date = (value as { date: unknown }).date;

        if (typeof date === 'string' && date.length > 0) {
            return normalizeContestPeriodDateToYmd(date);
        }
    }

    return null;
}

/** Парсит value из BaseDateTimePicker (range): массив, { start, end } или returnObject. */
export function parseContestPeriodRange(value: unknown): IContestSpecialPeriod | null {
    if (value == null || value === '') {
        return null;
    }

    if (Array.isArray(value)) {
        if (value.length < 2) {
            return null;
        }

        const from = toYmdString(value[0]);
        const to = toYmdString(value[1]);

        if (from && to) {
            return { from, to };
        }

        return null;
    }

    if (typeof value === 'object' && value !== null && 'start' in value && 'end' in value) {
        const range = value as { start: unknown; end: unknown };
        const from = toYmdString(range.start);
        const to = toYmdString(range.end);

        if (from && to) {
            return { from, to };
        }
    }

    return null;
}
